export default function AboutPage() {
  return (
    <section className="py-16">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-12">
          <span className="text-gold-500 text-5xl font-bold">ॐ</span>
          <h1 className="section-title text-4xl mt-3">About Cosmic Hindu</h1>
          <div className="section-divider" />
        </div>
        <div className="card-admin p-10 leading-relaxed">
          <p className="text-white/70 text-base mb-5">
            <strong className="text-gold-500">Cosmic Hindu</strong> was founded with a sacred mission — to bring authentic spiritual products to devotees worldwide. Based in the spiritual heartland of India, we source our products directly from trusted artisans, temples, and blessed craftsmen.
          </p>
          <p className="text-white/70 text-base mb-5">
            Every product in our collection is carefully selected and blessed before reaching you. From sacred Rudraksha beads sourced from Nepal to hand-carved God idols from Jaipur, we ensure the highest quality and authenticity.
          </p>
          <p className="text-white/70 text-base mb-8">
            Our team includes spiritual advisors, gemologists, and artisans who work together to bring you products that carry genuine divine energy. We believe that every spiritual item should be accessible to all seekers on their path.
          </p>
          <div className="grid grid-cols-3 gap-5 text-center">
            {[
              { num: '50,000+', label: 'Happy Devotees' },
              { num: '1,000+', label: 'Sacred Products' },
              { num: '100%', label: 'Authentic & Blessed' },
            ].map((s) => (
              <div key={s.label} className="p-5 bg-gold-500/5 rounded-lg border border-gold-500/[0.08]">
                <div className="text-2xl font-bold text-gold-500 font-display">{s.num}</div>
                <div className="text-xs text-white/40 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
